export const SYSTEM_MESSAGES_SESSION_KEY = "lk_system_messages_session";

const MAX_ENTRIES = 200;

function safeParseJson(raw, fallback) {
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

/** @returns {{ id: number, message: string, createdAt: string }[]} */
export function readSystemMessagesSession() {
  const list = safeParseJson(
    sessionStorage.getItem(SYSTEM_MESSAGES_SESSION_KEY),
    [],
  );
  return Array.isArray(list) ? list : [];
}

function writeSystemMessagesSession(list) {
  sessionStorage.setItem(
    SYSTEM_MESSAGES_SESSION_KEY,
    JSON.stringify(list.slice(-MAX_ENTRIES)),
  );
}

/** @returns {{ id: number, message: string, createdAt: string }} */
export function appendSystemMessageSession(message) {
  const trimmed = String(message ?? "").trim();
  if (!trimmed) {
    return null;
  }
  const prev = readSystemMessagesSession();
  const nextId =
    prev.reduce((max, item) => Math.max(max, Number(item.id) || 0), 0) + 1;
  const entry = {
    id: nextId,
    message: trimmed,
    createdAt: new Date().toISOString(),
  };
  writeSystemMessagesSession([...prev, entry]);
  return entry;
}

export function clearSystemMessagesSession() {
  sessionStorage.removeItem(SYSTEM_MESSAGES_SESSION_KEY);
}
